import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/insights', label: 'Insights' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-white/95 backdrop-blur border-b border-slate-200' : 'bg-white/80 backdrop-blur-sm'}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-[88px]">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="/waypoint-logo.webp"
              alt="Waypoint Transformation"
              className="h-12 lg:h-14 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `relative text-[14px] font-medium tracking-tight transition-colors ${isActive ? 'text-[#0F2A44]' : 'text-slate-600 hover:text-[#0F2A44]'}`
                }
              >
                {({ isActive }) => (
                  <>
                    {item.label}
                    <span className={`absolute left-0 -bottom-1.5 h-[2px] bg-[#0F2A44] transition-all duration-300 ${isActive ? 'w-full' : 'w-0'}`} />
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:16304479380" className="flex items-center gap-2 text-[13px] text-slate-600 hover:text-[#0F2A44] transition-colors">
              <Phone className="w-3.5 h-3.5" />
              1-630-447-9380
            </a>
            <Link to="/contact" className="px-5 py-2.5 bg-[#0F2A44] text-white text-[13px] font-medium tracking-tight hover:bg-[#1E3A5F] transition-colors rounded-sm">
              Get in touch
            </Link>
          </div>

          <button onClick={() => setOpen(!open)} className="lg:hidden text-[#0F2A44]" aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden border-t border-slate-200 py-4 space-y-1">
            {NAV.map((item) => (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => `block px-2 py-3 text-[15px] ${isActive ? 'text-[#0F2A44] font-semibold' : 'text-slate-700'}`}>
                {item.label}
              </NavLink>
            ))}
            <Link to="/contact" className="block mt-3 px-4 py-3 bg-[#0F2A44] text-white text-center text-sm rounded-sm">Get in touch</Link>
            <a href="tel:16304479380" className="block px-2 py-3 text-sm text-slate-600">1-630-447-9380</a>
          </div>
        )}
      </div>
    </header>
  );
}
